__turbopack_context__.v({
  "barFill": "nutrition-breakdown-modal-module__MFjBjG__barFill",
  "barTrack": "nutrition-breakdown-modal-module__MFjBjG__barTrack",
  "disclaimer": "nutrition-breakdown-modal-module__MFjBjG__disclaimer",
  "emptyText": "nutrition-breakdown-modal-module__MFjBjG__emptyText",
  "ingredientName": "nutrition-breakdown-modal-module__MFjBjG__ingredientName",
  "list": "nutrition-breakdown-modal-module__MFjBjG__list",
  "macroValue": "nutrition-breakdown-modal-module__MFjBjG__macroValue",
  "row": "nutrition-breakdown-modal-module__MFjBjG__row",
  "rowMeta": "nutrition-breakdown-modal-module__MFjBjG__rowMeta",
  "shareBadge": "nutrition-breakdown-modal-module__MFjBjG__shareBadge",
  "subtitle": "nutrition-breakdown-modal-module__MFjBjG__subtitle",
  "tab": "nutrition-breakdown-modal-module__MFjBjG__tab",
  "tabActive": "nutrition-breakdown-modal-module__MFjBjG__tabActive",
  "tabs": "nutrition-breakdown-modal-module__MFjBjG__tabs",
  "totalGda": "nutrition-breakdown-modal-module__MFjBjG__totalGda",
  "totalLabel": "nutrition-breakdown-modal-module__MFjBjG__totalLabel",
  "totalRow": "nutrition-breakdown-modal-module__MFjBjG__totalRow",
  "totalValue": "nutrition-breakdown-modal-module__MFjBjG__totalValue",
  "uncounted": "nutrition-breakdown-modal-module__MFjBjG__uncounted",
});
